<section class="container"
  class="py-4 text-center text-black d-flex flex-column align-items-center justify-content-center gap-2"
>
  <h2 class="display-6 fw-bold text-uppercase">{{ data?.title }}</h2>
  <ng-container *ngIf="data?.subTitle">
    <h4 class="fs-5 text-black fw-normal">{{ data?.subTitle }}</h4>
  </ng-container>
  <app-whatsapp-button [buttonText]="data?.buttonText" />
</section>
